import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { HelperBotType } from "../../constants/enum/enum";

import BuyCreditPopup from "../../components/HelperBotPopup/BuyCreditPopup";
import DepositCreditPopup from "../../components/HelperBotPopup/DepositCreditPopup";
import HelperBotFinishedPopup from "../../components/HelperBotPopup/HelperBotFinishedPopup";
import HelperBotStartPopup from "../../components/HelperBotPopup/HelperBotStartPopup";
import HelperList from "../../components/HelperList";

import useGameBankBalance from "../../hook/useGameBankBalance";
import useWallet from "../../hook/useWallet";
import { getUserHelperBotInfo } from "../../reducers/game.slice";
import { getMyProfile } from "../../reducers/profile.slice";
import { HelperBotEndInfo } from "../../types/HelperBotEndInfo";
import { toUSDFormat } from "../../utils/utils";
import useHelperBotSSE from "./hooks/useHelperBotSSE";

import useStyles from "./index.styles";

const HelperBot = () => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const { account } = useWallet();
  const { myProfile, helperCreditBalance } = useAppSelector(
    (state) => state.profile
  );
  const { signMsg, signature } = useAppSelector((state) => state.auth);
  const { updateBalance } = useGameBankBalance(account, signMsg, signature);

  const [openFinishedPopup, setOpenFinishedPopup] = useState(false);
  const [openStartBotPopup, setOpenStartBotPopup] = useState(false);
  const [openDepositCreditPopup, setOpenDepositCreditPopup] = useState(false);
  const [openBuyCreditPopup, setOpenBuyCreditPopup] = useState(false);
  const [botEndedInfo, setBotEndedInfo] = useState<HelperBotEndInfo>({
    user: "",
    botType: 0,
    xpEarned: 0,
    cashEarned: 0,
    carCount: 0,
    cashSpent: 0,
    bulletEarned: 0,
    ownerProfit: 0,
    timestamp: 0,
  });

  const [currentSelectedBot, setCurrentSelectedBot] = useState<HelperBotType>(
    HelperBotType.CrimeBot
  );

  const handleCurrentSelectedBotChanged = (botType: HelperBotType) => {
    setCurrentSelectedBot(botType);
    setOpenStartBotPopup(true);
  };

  const handleOnStarted = () => {};

  const handleOnEnded = (botEndedInfo: HelperBotEndInfo) => {
    setBotEndedInfo(botEndedInfo);
    setOpenFinishedPopup(true);
    updateBalance(account, signMsg, signature);

    myProfile.name && dispatch(getMyProfile(myProfile.name));
  };

  useEffect(() => {
    dispatch(getUserHelperBotInfo(account));
  }, [account, dispatch]);

  useHelperBotSSE(account, handleOnStarted, handleOnEnded);

  return (
    <Box className={classes.body}>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <Box className={classes.headerInfo}>
            <Typography
              fontFamily={"Philosopher"}
              color={"white"}
              textAlign={"center"}
              fontSize={36}
              fontWeight={700}
            >
              Helper Bot
            </Typography>

            <Typography
              fontFamily={"Philosopher"}
              color={"grey"}
              fontSize={14}
              fontWeight={700}
            >
              Available credits: {toUSDFormat(Math.floor(helperCreditBalance))}
            </Typography>
          </Box>

          <Box className={classes.headerButtons}>
            <Button
              startIcon={
                <Box
                  component="img"
                  src={"/assets/imgs/inventory/helperitem.png"}
                />
              }
              variant="contained"
              color="primary"
              size="large"
              className={classes.headerButton}
              onClick={() => setOpenDepositCreditPopup(true)}
            >
              Deposit item
            </Button>

            <Button
              startIcon={
                <Box
                  component="img"
                  src={"/assets/imgs/inventory/helperitem.png"}
                />
              }
              variant="contained"
              color="primary"
              size="large"
              className={classes.headerButton}
              onClick={() => setOpenBuyCreditPopup(true)}
            >
              Buy credits
            </Button>
          </Box>
        </Box>

        <HelperList
          handleCurrentSelectedBotChanged={handleCurrentSelectedBotChanged}
        />
      </Box>

      <HelperBotFinishedPopup
        botEndedInfo={botEndedInfo}
        openModal={openFinishedPopup}
        setOpenModal={setOpenFinishedPopup}
      />

      <HelperBotStartPopup
        currentSelectedBot={currentSelectedBot}
        openModal={openStartBotPopup}
        setOpenModal={setOpenStartBotPopup}
      />

      <DepositCreditPopup
        openModal={openDepositCreditPopup}
        setOpenModal={setOpenDepositCreditPopup}
      />

      <BuyCreditPopup
        openModal={openBuyCreditPopup}
        setOpenModal={setOpenBuyCreditPopup}
      />
    </Box>
  );
};

export default HelperBot;
